<p class="pretext">
  <transloco
    id="965d9dfc-3b3a-483c-b7eb-f5b18155a79f"
    [key]="
      updatePasswordMode === 'setPassword'
        ? 'accountUi.checkRecoveryEmail.weHaveSentAnEmailToSetAPassword'
        : 'accountUi.checkRecoveryEmail.weHaveSentAnEmailToSetANewPassword'
    "
    [params]="{ emailClass: 'email', email: this.email, id: '94d5eacb-f8c5-48fc-8b20-ccf8049e934f' }"></transloco>
</p>

<ng-template #setPasswordTranslation>{{ 'accountUi.checkRecoveryEmail.setA' | transloco }}</ng-template>
<ng-template #setNewPasswordTranslation>{{ 'accountUi.checkRecoveryEmail.setNew' | transloco }}</ng-template>

<yat-polling-status id="29d6c5c5-7380-43a7-8b08-a35c3b123ebc" [configuration]="extendedConfiguration"
  >{{
    (updatePasswordMode === 'setPassword'
      ? 'accountUi.checkRecoveryEmail.pollingStatusWaitingForPassword'
      : 'accountUi.checkRecoveryEmail.pollingStatusWaitingForNewPassword'
    ) | transloco
  }}
</yat-polling-status>

<ng-container *ngIf="!proceeding">
  <div class="subtext">{{ 'accountUi.checkRecoveryEmail.didntGetEmail' | transloco }}</div>
  <div class="subtext" yat-link>
    <transloco
      id="2c612ca7-02df-4ac4-a005-759c2247497f"
      *ngIf="cancelPasswordUpdateText === 'backToSignIn'"
      key="accountUi.checkRecoveryEmail.resendEmailOrGoBackToSignIn"
      [params]="{ resendEmailLink, goBackToSignInLink: cancelLink }"></transloco>
    <transloco
      id="b03c6287-607b-4d21-9b6c-7ade80581b93"
      *ngIf="cancelPasswordUpdateText === 'proceed'"
      key="accountUi.checkRecoveryEmail.resendEmailOrProceed"
      [params]="{ resendEmailLink, proceedLink: cancelLink }"></transloco>
  </div>
</ng-container>
